export const INCREASE = 'INCREASE';
export const SET = 'SET';